import React from 'react';

import StandingsTable from './StandingsTable';
import { useStandings } from '../../queries/standings';
import { useSchema } from '../../queries/schema';
import { getSchemaProperties } from '../../lib/schemaFormating';
import { useSorting } from '../../lib';

const Standings = ({ filters, data, disableSorting, ...props }) => {
  const { currentSortData, currentSortOrder, handleSorting } = useSorting();
  const { data: currentRows = [], status: standingsStatus } = useStandings(filters, currentSortData, currentSortOrder);
  const { data: schema, status: schemaStatus } = useSchema(currentRows);
  const groups = data && data.groups; // via MainFilters
  const properties = getSchemaProperties(schema, currentRows, currentSortData);

  let groupedRows = [{ rows: currentRows }]
  if (groups && groups.length) {
    groupedRows = groups
      .map(group => ({
        id: group.id,
        name: group.name,
        rows: currentRows.filter(row => row.groupId === group.id)
      }))
      .filter(group => group.rows.length > 0)

    const noGroup = currentRows.filter(row => !row.groupId);
    if (noGroup.length) {
      groupedRows.push({ id: 0, name: 'No Group', rows: noGroup })
    }
  }

  return <StandingsTable
    filters={filters}
    currentRows={currentRows}
    groups={groupedRows}
    statuses={[standingsStatus, schemaStatus]}
    properties={properties}
    disableSorting={disableSorting}
    querySort={currentSortData}
    queryOrder={currentSortOrder}
    handleSorting={handleSorting}
    {...props}
  />
}

export default Standings;
